module.exports = __webpack_public_path__ + "img/system_framework.67fb42a8.png";